import { render, staticRenderFns } from "./RIDCreateView.vue?vue&type=template&id=39d1b262&scoped=true"
import script from "./RIDCreateView.vue?vue&type=script&lang=js"
export * from "./RIDCreateView.vue?vue&type=script&lang=js"
import style0 from "./RIDCreateView.vue?vue&type=style&index=0&id=39d1b262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d1b262",
  null
  
)

export default component.exports